import { Box } from '@material-ui/core';
import UnitSpecification from './UnitSpecification';
import FinalizeSectionData from './FinalizeSectionData';
import { useDispatch, useSelector } from 'react-redux';
import getIdForModel from '../../utils/getIdForModel';
import { useEffect } from 'react';
import { getVariantsForCIEM } from '../../reducers/shopify_api/ShopifyCIEMSlice';
import { useTranslation } from 'react-i18next';
import LineItem from './LineItem';
import { useMemo } from 'react';
import { getTypeOfOption } from '../../utils/getType';

const OrderDetailScrollable = () => {
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const model = useSelector((state) => state.rootReducer.currentModel);
    const id = getIdForModel(state.shopifyReducer.ciems, model.currentModel.name);
    const shell = state.rootReducer.currentShell;
    const faceplate = state.rootReducer.currentFaceplateOption;
    const artwork = state.rootReducer.currentArtwork;
    const cable = state.rootReducer.currentCableOption;
    const carePlanSelected = state.rootReducer.finalizeForm.carePlanSelected;
    const carePlanPrice = state.rootReducer.iemPrice.carePlan;
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    const leftFaceplateType = useMemo(() => {
        return getTypeOfOption(faceplate.leftOption.SK);
    }, []);
    const rightFaceplateType = useMemo(() => {
        return getTypeOfOption(faceplate.rightOption.SK);
    }, []);
    const { t } = useTranslation();
    useEffect(() => {
        if (id) {
            dispatch(getVariantsForCIEM(id));
        }
    }, [id]);
    useEffect(() => {
        console.log('model', state);
    }, [model]);
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                width: '90%',
                marginLeft: '2%',
                marginRight: '2%',
                alignItems: 'center',
                justifyContent: 'center',
                direction: 'ltr',
                height: '98%',
                overflow: 'auto'
            }}>
            <UnitSpecification
                title={t('order_details.shell')}
                left={shell.leftShell}
                right={shell.rightShell}
            />
            <UnitSpecification
                title={t('order_details.faceplate')}
                left={faceplate.leftOption}
                leftType={leftFaceplateType}
                right={faceplate.rightOption}
                rightType={rightFaceplateType}
            />
            <UnitSpecification
                title="Artwork"
                left={artwork.leftArtwork}
                right={artwork.rightArtwork}
            />
            <LineItem
                title={t('order_details.cable')}
                value={cable.activeCableType.split(' ')[0]}
                price={`${currency}0.00`}
            />
            <LineItem title="" value={cable.activeCableColor} price={`${currency}0.00`} />
            <LineItem title="" value={cable.activeCableLength} price={`${currency}0.00`} />
            <LineItem
                title="Care Plan"
                value={carePlanSelected}
                price={`${currency}${
                    carePlanSelected === 'Yes Care Plan Added'
                        ? parseFloat(carePlanPrice).toFixed(2)
                        : carePlanSelected === 'No Care Plan Added'
                        ? '0.00'
                        : '0.00'
                }`}
            />
            <FinalizeSectionData />
        </Box>
    );
};

export default OrderDetailScrollable;
